import { Chip, Icon } from '@aibees/shared/components';
import { BOOK_A_DEMO_URL } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';
import { featuresText } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { AgencyAndEnterpriseCardProps as Props } from './types';

const TOOLTIP_POPPER_PROPS = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [120, -10],
      },
    },
  ],
};

export const AgencyAndEnterpriseCard = memo(({ className }: Props) => {
  const handleContactClick = () => {
    window.open(BOOK_A_DEMO_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Styled.Wrapper
      className={classnames('AgencyAndEnterpriseCard', className)}
      sx={SX.root}
    >
      <Box>
        <Chip
          label="Custom Plan"
          variant="outlined"
          shape="rounded"
          color="primary"
          size="small"
        />
      </Box>
      <Typography sx={SX.title}>Agency & Enterprise Plan</Typography>
      <Typography variant="body4" fontWeight={400} mb={4} color="grey.600">
        Unlock the full power of the Ark with our Agency & Enterprise Plan
      </Typography>

      <Typography variant="body4" fontWeight={700} mb={1} color="grey.500">
        PerGet access to:
      </Typography>
      <Stack gap={0.5} mb={1}>
        {featuresText?.map((f, i) => (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            key={i.toString()}
          >
            <Box
              display="flex"
              alignItems="center"
              flex={1}
              gap={0.5}
              minWidth={0}
            >
              <Tooltip
                title={f.tooltip}
                placement="top"
                PopperProps={TOOLTIP_POPPER_PROPS}
              >
                <Icon size={16} name="info" sxx={SX.icon} />
              </Tooltip>
              <Typography variant="body4" fontWeight={700} color="common.black">
                {f.text}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>

      <Button
        variant="contained"
        color="primary"
        sx={SX.button}
        onClick={handleContactClick}
        size="small"
      >
        Contact us
      </Button>
    </Styled.Wrapper>
  );
});

AgencyAndEnterpriseCard.displayName = 'AgencyAndEnterpriseCard';
